import { getBaseUrl, request } from 'src/helper/api';

// All four write actions hit the SINGULAR `vendor-preference/actions/{slug}`
// path (the reads use the PLURAL `vendor-preferences`). Isolate the write URL
// builder so the singular/plural split is stated once and can't drift.
const actionUrl = (slug: string) => `${getBaseUrl()}api/vendor-preference/actions/${slug}`;

// GET api/vendor-preferences?market_uuid=… — the query (`{ market_uuid }`)
// rides in the dispatched thunk payload, exactly like markets' GET thunks.
export const fetchVendorPreferences = (token?: string, signal?: AbortSignal) =>
  request(
    { method: 'GET', url: `${getBaseUrl()}api/vendor-preferences`, token, signal },
    'vendorPreferences/fetchVendorPreferences',
  );

// GET api/vendor-preferences/eligible-vendors?market_uuid=…&problem_category_uuid=…
// &problem_sub_category_uuid?=… — query rides in the dispatched payload.
export const fetchEligibleVendors = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/vendor-preferences/eligible-vendors`,
      token,
      signal,
    },
    'vendorPreferences/fetchEligibleVendors',
  );

// POST setCategoryDefault — body { market_uuid, problem_category_uuid, vendor_uuids[] }.
export const setCategoryDefault = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: actionUrl('setCategoryDefault'),
      contentType: 'json',
      token,
      signal,
      shouldAddSocketId: true,
    },
    'vendorPreferences/setCategoryDefault',
  );

// POST setSubCategoryOverride — body { market_uuid, problem_category_uuid,
// problem_sub_category_uuid, vendor_uuids[] }.
export const setSubCategoryOverride = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: actionUrl('setSubCategoryOverride'),
      contentType: 'json',
      token,
      signal,
      shouldAddSocketId: true,
    },
    'vendorPreferences/setSubCategoryOverride',
  );

// POST customizeSubCategory — body { market_uuid, problem_category_uuid,
// problem_sub_category_uuid }.
export const customizeSubCategory = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: actionUrl('customizeSubCategory'),
      contentType: 'json',
      token,
      signal,
      shouldAddSocketId: true,
    },
    'vendorPreferences/customizeSubCategory',
  );

// POST resetSubCategoryToDefault — body { market_uuid, problem_category_uuid,
// problem_sub_category_uuid }. Returns a MESSAGE, not a list resource.
export const resetSubCategoryToDefault = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: actionUrl('resetSubCategoryToDefault'),
      contentType: 'json',
      token,
      signal,
      shouldAddSocketId: true,
    },
    'vendorPreferences/resetSubCategoryToDefault',
  );
